export const PROJECT_NAME = 'Emaar Beachfront Dubai'

export const EMAIL_JS_PUBLIC_KEY = "hNfRE6-HrKnVHAh-3"

export const EMAIL_JS_TEMPLATE_ID = "template_jsI0rss"

export const  EMAIL_JS_SERVICE_ID = "service_1sq9clp"

export const ENQUIRY_CTA = {
    NAV_DOWNLOAD_BROCHURE: "download brochure",
    GET_COMPLETE_COSTING_DETAILS: "get complete costing details",
    INTRO: "intro",
    PRICING: "pricing",
    PAYMENT_PLAN: "payment plan",
    MASTER_PLAN: "master plan",
    UNIT_PLAN: "unit plan",
    AMENITIES: "amenities",
    GALLERY: "gallery",
    LOCATION: "location",
    EOI_PATCH: "eoi patch",
    FOOTER: "footer"
}